import { Controller } from "@hotwired/stimulus";
import { lineSpinner } from "ldrs";

lineSpinner.register();

export default class extends Controller {
  static values = {
    submittingText: String,
    loaderTitle: String,
    loaderSubtitle: String,
  };

  connect() {
    this._submitEvent = this.element.dataset.turboConfirm
      ? "turbo:submit-start"
      : "submit";
    this.element.addEventListener(this._submitEvent, this.#handleSubmit);
    this.element.addEventListener("turbo:submit-end", this.#handleEnd);
  }

  disconnect() {
    this.element.removeEventListener(this._submitEvent, this.#handleSubmit);
    this.element.removeEventListener("turbo:submit-end", this.#handleEnd);
    this.#removeOverlay();
  }

  #handleSubmit = (e) => {
    const btn = e.submitter || this.element.querySelector('[type="submit"]');
    if (!btn || btn.disabled) return;

    btn.disabled = true;
    btn.classList.add("btn--loading");

    // Lightweight actions (e.g. draft save) get their own inline spinner —
    // the full-screen "generating your video" overlay is reserved for the
    // actual render kickoff and would misrepresent a quick save as a
    // long-running job.
    if (btn.dataset.lightweightSubmit === "true") return;
    this.#showOverlay();
  };

  #handleEnd = () => {
    this.#removeOverlay();
  };

  #showOverlay() {
    if (this._overlay) return;

    const overlay = document.createElement("div");
    overlay.className = "submit-overlay";
    overlay.setAttribute("aria-live", "assertive");
    overlay.setAttribute("role", "alert");

    const content = document.createElement("div");
    content.className = "submit-overlay__content";

    const spinner = document.createElement("l-line-spinner");
    spinner.setAttribute("size", "40");
    spinner.setAttribute("stroke", "3");
    spinner.setAttribute("speed", "1");
    // Overlay backdrop is fixed dark regardless of theme — fixed white, not a
    // theme token (and --white never existed as a token anyway).
    spinner.setAttribute("color", "#fff");

    const title = document.createElement("h2");
    title.className = "submit-overlay__title";
    title.textContent = this.loaderTitleValue || "";

    const subtitle = document.createElement("p");
    subtitle.className = "submit-overlay__subtitle";
    subtitle.textContent = this.loaderSubtitleValue || "";

    content.append(spinner, title, subtitle);
    overlay.appendChild(content);
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add("submit-overlay--visible"));
    this._overlay = overlay;
  }

  #removeOverlay() {
    if (this._overlay) {
      this._overlay.remove();
      this._overlay = null;
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
  }
}
